export function formatTime(timeMinutes: number): string {
    const hour = Math.floor(timeMinutes / 60).toString().padStart(2, '0');
    const minute = (timeMinutes % 60).toString().padStart(2, '0');
    return `${hour}:${minute}`;
}

export function parseTime(time: string): number | null {
    const match = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(time);
    if (match == null) return null;
    return Number(match[1]) * 60 + Number(match[2]);
}
